import React from 'react';
import { LeadDetailsModel } from '@/typings/models/Lead';
import LeadFiles from '@/components/ProjectDetails/Cards/LeadFiles';

export interface FilesDrawerProps {
  leadId: string;
  leadDetails: LeadDetailsModel;
  onRefresh?: () => void;
  payload?: { mode?: string; [key: string]: any };
}

/**
 * Files drawer that displays lead files with upload capabilities
 * Reuses the existing LeadFiles component for consistency
 */
const FilesDrawer: React.FC<FilesDrawerProps> = ({
  leadDetails,
  onRefresh,
}) => {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <LeadFiles
      leadDetails={leadDetails}
      refresh={handleRefresh}
    />
  );
};

export default FilesDrawer;
